<script setup>
import TitleComponent from '@/components/TitleComponent/index.vue'
import { getReleaseListOrder, productShelvesOrder, productDelOrder } from '@/apis/order'
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n'
import { formatToLocalTime } from '@/utils/index'
import { useUserStore } from '@/stores/userStore'
import { goUp } from '@/utils/index'
const userStore = useUserStore()
const { t } = useI18n();
let router = useRouter();
const ipTime = userStore.ipTime;

const dialogVisible=ref(false)

// tab列表
const tabTypes = [
    { name: "all", label: t('number110') },
    // { name: "unpay", label: "待付款" },
    // { name: "complete", label: "已完成" }
]
// 总数量
const total = ref(0)
// 获取订单列表
const orderList = ref([])
const params = reactive({
    fromData: {
        name: '',
        page: 1,
        pageSize: 5
    }

})

const getOrderList = async () => {
    const res = await getReleaseListOrder(params.fromData)
    if (res.code == 0) {
        orderList.value = res.data.data || []
        // if(orderList.value?.length>0){
        //     orderList.value.map(item=>{
        //     item.images=JSON.parse(item.images);
        //     })
        // }

        total.value = res.data.total
    }

}
const loading = ref(false)
const noMore = computed(() => {

    if (orderList.value) {
        if (orderList.value?.length >= total.value) {
            return true;
        } else {
            return false;
        }
    }
})
const disabled = computed(() => loading.value || noMore.value)
const load = () => {

    loading.value = true
    setTimeout(async () => {
        params.fromData.page++
        const res = await getReleaseListOrder(params.fromData)
        if (res.data.data) {
            orderList.value = [...orderList.value, ...res.data.data]
            loading.value = false
        }
    }, 100)
}
const goDetails = (id) => {
    router.path({ path: '/detail/' + id })

    // const url = router.resolve({
    //     path: '/',
    // }).href
    // window.open(url, '_blank')
    // 打开新窗口
    // // 使用 router.resolve 获取路由信息
    // const routeData = router.resolve('/');
    // // 使用 window.open 在新窗口打开链接
    // window.open(routeData.href, '_blank');
}
const isMobile = ref(false);//false代表pc
onMounted(() => {
    getOrderList()
    isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    console.log('Is mobile device:', isMobile.value);
})




// 页数切换
const pageChange = (page) => {
    console.log(page);
    params.fromData.page = page
    getOrderList()
}

const delOrder = (id) => {
    ElMessageBox.confirm(
        t('number111'),
        {
            cancelButtonText: 'Cancel',
            confirmButtonText: 'OK',
            type: 'warning',
        }
    )
        .then(async () => {
            const res = await productDelOrder({ id: id })
            if (res.code == 0) {
                ElMessage({ type: 'success', message: t('number112') })
                getOrderList()
            } else {
                ElMessage({ type: 'error', message: res.message })
            }
        })
        .catch(() => {
            ElMessage({
                type: 'info',
                message: t('number113'),
            })
        })

}
const shelvesOrder = async (id, type) => {
    let data = {
        id: id,
        status: type
    }
    ElMessageBox.confirm(
        type == 1 ? t('number114') : t('number115'),

        {
            cancelButtonText: 'Cancel',
            confirmButtonText: 'OK',
            type: 'warning',
        }
    )
        .then(async () => {
            const res = await productShelvesOrder(data)
            if (res.code == 0) {
                ElMessage({ type: 'success', message: t('number116') })
                getOrderList()
            } else {
                ElMessage({ type: 'error', message: res.message })
            }
        })
        .catch(() => {
            ElMessage({
                type: 'info',
                message: t('number113'),
            })
        })
}

const goEdit = (id) => {
    // 使用 router.resolve 获取路由信息
    const routeData = router.resolve('/add/' + id);
    // 使用 window.open 在新窗口打开链接
    window.open(routeData.href, '_blank');
}

</script>

<template>
    <TitleComponent :title="t('number9')" v-if="isMobile == true"></TitleComponent>
    <div class="fabu" @click="dialogVisible=true">
        <img style="width: 23px;height: 23px;" src="../../../assets/images/fabu.png" alt="" srcset="">
    </div>
    <div class="order-container">
        <div class="buy-title" v-if="isMobile == false">
            {{ $t('number9') }}
        </div>
        <div class="main-container">
            <div class="holder-container" v-if="orderList.length === 0">
                <el-empty :description="t('number80')" />
            </div>
            <div v-else>
                <div v-if="isMobile == false">
                    <!-- 订单列表 -->
                    <div class="order-item" v-for="order in orderList" :key="order.id">
                        <div class="head">
                            <div>{{ $t('number66') }}:{{ formatToLocalTime(ipTime, order.createdAt) }}</div>
                        </div>
                        <div class="body">
                            <div class="column goods">
                                <ul>
                                    <li @click="$router.push('/detail/' + order.id)">
                                        <a class="image" href="javascript:;">
                                            <img :src="order.images[0]" alt="" />
                                        </a>
                                        <div class="info">
                                            <p class="name ellipsis-2">
                                                {{ order.name }}
                                            </p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div class="seesaw">
                                <div class="price">{{ order.status == 1 ? t('number117') : t('number118') }}</div>

                            </div>
                            <div class="amount">
                                <p class="red">¥{{ goUp(order.price) }}</p>
                            </div>
                            <div class="action contentflex">
                                <div>
                                    <p class="ProductButton HorizontalCenter" @click="shelvesOrder(order.id, 1)"
                                        v-if="order.status == 2">{{ $t('number117') }}</p>
                                    <p class="ProductButton HorizontalCenter" @click="shelvesOrder(order.id, 2)"
                                        v-if="order.status == 1">{{ $t('number118') }}</p>
                                    <p class="ProductButton HorizontalCenter" @click="goEdit(order.id)">
                                        {{ $t('number24') }}</p>
                                    <p class="ProductButton HorizontalCenter" @click="delOrder(order.id)"
                                        v-if="order.status != 1">{{ $t('number119') }}</p>
                                    <p class="ProductButton HorizontalCenter"
                                        @click="$router.push('/detail/' + order.id)">{{ $t('number120') }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 分页 -->
                    <div class="pc contentflex">
                        <el-pagination :total="total" @current-change="pageChange" :page-size="params.fromData.pageSize"
                            background layout="prev, pager, next" />
                    </div>
                </div>
                <div v-else class="infinite-list-wrapper" style="overflow: auto">
                    <ul v-infinite-scroll="load" class="list" :infinite-scroll-disabled="disabled">
                        <div class="order-item" v-for="order in orderList" :key="order.id">
                            <div class="head">
                                <span>{{ $t('number82') }}:{{ formatToLocalTime(ipTime, order.createdAt) }}</span>
                                <!-- <span>{{$t('number45')}}:{{ order.id }}</span> -->

                            </div>
                            <div class="phonebody">
                                <div class="column goods">
                                    <ul>
                                        <li @click="$router.push('/detail/' + order.id)">
                                            <a class="image" href="javascript:;">
                                                <img :src="order.images[0]" alt="" />
                                            </a>
                                            <div class="info">
                                                <p class="name ellipsis-2">
                                                    {{ order.name }}
                                                </p>
                                                <div class="seesaw">
                                                    {{ order.status == 1 ? t('number117') : t('number118') }}
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div class="bodyButton aboutflex">
                                    <div class="amount">
                                        ${{ goUp(order.price) }}
                                    </div>
                                    <div class="contentflex">
                                        <div class="phoneProductButton" size="small" @click="shelvesOrder(order.id, 1)"
                                            v-if="order.status == 2" round>{{ $t('number117') }}</div>
                                        <div class="phoneProductButton" size="small" @click="shelvesOrder(order.id, 2)"
                                            v-if="order.status == 1" round>{{ $t('number118') }}</div>
                                        <div class="phoneProductButton" size="small" @click="delOrder(order.id)"
                                            v-if="order.status != 1" round>{{ $t('number119') }}</div>
                                        <div class="phoneProductButton" size="small"
                                            @click="$router.push('/detail/' + order.id)" round>{{ $t('number58') }}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </ul>
                    <p v-if="loading" style="text-align: center;">Loading...</p>
                    <p v-if="noMore" style="text-align: center;">No more</p>
                </div>

            </div>
        </div>
    </div>
    <el-dialog
        v-model="dialogVisible"
        width="70vw"
        :show-close="false"
        style="padding:20px 0 0;"
    >
        <div style="text-align: center;width: 100%;">{{$t('setup545')}}</div>
        <template #header="{ close, titleId, titleClass }">
            <div class="my-header">
                {{$t('setup543')}}

            </div>
        </template>
        <template #footer>
        <div class="dialog-footer" @click="dialogVisible=false">
            <div>{{$t('home5')}}</div>
            <div>{{$t('home4')}}</div>
        </div>
        </template>
    </el-dialog>
</template>

<style scoped lang="scss">
.order-container {
    background: #ffffff;
    padding: 10px 20px;
    border-radius: 8px;
    height: 100%;

    .buy-title {
        padding: 20px 0 20px 0;
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 18px;
        color: #11192D;
        line-height: 18px;
        text-align: left;
        font-style: normal;
    }


    .main-container {
        min-height:100vh;

        .holder-container {
            min-height: 100vh;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
}

.fabu {
    position: fixed;
    top: 10px;
    right: 15px;
    z-index: 10000;
}

.order-item {
    margin-bottom: 20px;
    // border: 1px solid #f5f5f5;

    .head {
        padding: 18px 20px;
        background: #F3F6F8;
        border-radius: 8px 8px 0px 0px;
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #11192D;
        line-height: 19px;
        text-align: left;
        font-style: normal;
    }

    .body {
        display: flex;
        align-items: center;
        background: #FFFFFF;
        border-radius: 0px 0px 8px 8px;
        border: 1px solid #E5E8EC;
        border-top: none;

        .column {
            // border-left: 1px solid #f5f5f5;
            text-align: center;
            padding: 20px 0 20px 20px;

            >p {
                padding-top: 10px;
            }

            &:first-child {
                border-left: none;
            }

            &.goods {
                // flex: 1;
                // padding: 0;
                // align-self: center;

                ul {
                    li {
                        border-bottom: 1px solid #f5f5f5;
                        // padding: 10px;
                        display: flex;

                        &:last-child {
                            border-bottom: none;
                        }

                        .image {
                            width: 78px;
                            height: 78px;
                            border: 1px solid #F5F6F8;
                            background: #F5F6F8;
                            border-radius: 8px;

                            img {
                                width: 100%;
                                height: 100%;
                                border-radius: 8px;
                            }
                        }

                        .info {
                            width: 300px;
                            padding-left: 13px;

                            .name {
                                font-family: MicrosoftYaHei, MicrosoftYaHei;
                                font-weight: bold;
                                font-size: 16px;
                                color: #11192D;
                                line-height: 25px;
                                text-align: left;
                                font-style: normal;
                            }

                        }


                    }
                }
            }

        }

        .seesaw {
            text-align: center;
            width: 120px;
            font-family: MicrosoftYaHei;
            font-size: 14px;
            color: #666666;
            line-height: 28px;
            // text-align: right;
            font-style: normal;
        }


        .amount {
            text-align: center;
            width: 120px;
            font-family: MicrosoftYaHei, MicrosoftYaHei;
            font-weight: bold;
            font-size: 14px;
            color: #FC3938;
            line-height: 19px;
            font-style: normal;
        }

        .action {
            width: 200px;
            padding: 0 20px 0 0;
        }
    }
}

@media (max-width: 768px) {

    .order-container {
        background-color: #f3f3f3;
        margin-top: 45px;
        padding: 15px 15px 30px 15px;
        height: auto;
        // padding: 10px 10px 60px 10px;

        .order-item {
            .head {
                background-color: #ffffff;
                padding: 17px 15px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 12px;
                color: #333333;
                line-height: 12px;
                text-align: left;
                font-style: normal;
                border-bottom: 1px solid #EEEEEE;
            }

            .phonebody {
                display: flex;
                flex-direction: column;
                background: #FFFFFF;
                border-radius: 0px 0px 8px 8px;
                // border: 1px solid #E5E8EC;s
                border-top: none;

                .column {
                    // border-left: 1px solid #f5f5f5;
                    text-align: center;
                    padding: 20px 0 20px 20px;

                    >p {
                        padding-top: 10px;
                    }

                    &:first-child {
                        border-left: none;
                    }

                    &.goods {
                        // flex: 1;
                        // padding: 0;
                        // align-self: center;

                        ul {
                            li {
                                border-bottom: 1px solid #f5f5f5;
                                // padding: 10px;
                                display: flex;

                                &:last-child {
                                    border-bottom: none;
                                }

                                .image {
                                    width: 78px;
                                    height: 78px;
                                    border: 1px solid #F5F6F8;
                                    background: #F5F6F8;
                                    border-radius: 8px;

                                    img {
                                        width: 100%;
                                        height: 100%;
                                        border-radius: 8px;
                                    }
                                }

                                .info {
                                    width: 223px;
                                    padding-left: 13px;

                                    .name {
                                        font-family: MicrosoftYaHei, MicrosoftYaHei;
                                        font-weight: bold;
                                        font-size: 16px;
                                        color: #11192D;
                                        line-height: 25px;
                                        text-align: left;
                                        font-style: normal;
                                    }

                                    .seesaw {
                                        padding-top: 15px;
                                        font-family: PingFangSC, PingFang SC;
                                        font-weight: 400;
                                        font-size: 14px;
                                        color: #888888;
                                        line-height: 20px;
                                        text-align: left;
                                        font-style: normal;
                                    }

                                }


                            }
                        }
                    }

                }

                .bodyButton {
                    border-top: 1px solid #EEEEEE;
                    padding: 10px 20px;

                    .amount {
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 400;
                        font-size: 12px;
                        color: #FF4F00;
                        line-height: 14px;
                        text-align: left;
                        font-style: normal;
                    }
                }




                .action {
                    width: 200px;
                    padding: 0 20px 0 0;
                }
            }
        }
    }
   
    .my-header{
        color: #222;
        font-size: 16px;
        font-weight: 600;
        text-align: center;
    }
    .dialog-footer{
            display: flex;
            align-items: center;
            width: 100%;
            border-top: 1px solid #eee;

            >div{
                width: 50%;
                height: 50px;
                font-weight: 400;
                font-size: 16px;
                color: #249FF6;
                line-height: 50px;
                text-align: center;
                font-style: normal;
            }
            >div:first-child{
                border-right: 1px solid #eee;
                color: #999;
            }
        }
    .but {
        display: flex;
        padding: 10px;
        justify-content: flex-end;
    }
}
</style>